import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AtasSociosService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  requestAtasSocios(codEmpresa: string, valor: string, codJucesp: string) {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/ata-socios-report?codEmpresa=${codEmpresa}&valor=${encodeURIComponent(valor)}&codJucesp=${codJucesp}`);

  }

}

